import React from "react";
import About from "./About";
import LayoutHeader from "./Header";
import Hero from "./Hero";
import Partners from "./Partners";
import ProjectWebsite from "./ProjectWebsite";

const Layout = () => {
  return (
    <div>
      <div className="pb-40 bg-gradient-to-b from-greenish/10 to-white min-h-[90vh]">
        <LayoutHeader />
        <Hero />
        <About />
        <Partners />
        <ProjectWebsite />
      </div>
    </div>
  );
};

export default Layout;
